import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../../partials/content/CustomDataTableSearch";
import { getVendorBankAccount } from "../../../../../services/inventory/vendorService";

function SearchVendorBankAccount({ vendorID = 0, onSelectBankAccount }) {
  const [bankAccounts, setBankAccounts] = useState([]);
  const getVendorBankAccountData = async (vendorID = 0) => {
    const response = await getVendorBankAccount(vendorID);
    const { data } = response.data;
    setBankAccounts(data.bankAccounts);
  };
  useEffect(() => {
    getVendorBankAccountData(vendorID);
  }, [vendorID]);
  return (
    <CustomDataTableSearch
      data={bankAccounts}
      onRefreshData={() => {
        this.getVendors();
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectBankAccount(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectBankAccount(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "Account Number",
          field: "accountNo",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Account Holder",
          field: "accountHolder",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Bank Name",
          field: "bankName",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Bank Branch",
          field: "bankBranch",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "SWIFT / Bank Code",
          field: "bankCode",
          body: null,
          sortable: true,
          filter: true,
        },
      ]}
    />
  );
}

export default SearchVendorBankAccount;
